import { render, staticRenderFns } from "./FtaTable.vue?vue&type=template&id=16411a9b&scoped=true"
import script from "./FtaTable.vue?vue&type=script&lang=js"
export * from "./FtaTable.vue?vue&type=script&lang=js"
import style0 from "./FtaTable.vue?vue&type=style&index=0&id=16411a9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16411a9b",
  null
  
)

export default component.exports